import { useEffect, useState } from "react";
// import { useStore } from "react-redux"; // COMMENTED OUT — useStore is imported but never called anywhere in this file or the project
import { firestore } from "../../firebase/config";
import { getDoc, collection, doc, onSnapshot } from "firebase/firestore";

/**
 *
 * @param {*} sDate Date value in string format
 * @returns
 * The value of the financial year in YYYY-YY format e.g. 2021-22
 */
export function getFYofDate(sDate) {
  const tDate = new Date(sDate);
  let year = tDate.getFullYear();
  let preYear = year - 1;
  let nextYear = year + 1;
  let month = tDate.getMonth();

  if (month < 3) {
    //From Jan to Mar
    return preYear.toString() + "-" + year.toString().substring(2, 4);
  } else {
    //From Apr to Dec
    return year.toString() + "-" + nextYear.toString().substring(2, 4);
  }
}
/**
 * returns date in dd-mon-yyyy format
 */
export function getDateInFormat(sDate) {
  const monthArray = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const dDate = new Date(sDate);
  return sDate !== undefined && sDate !== ""
    ? dDate.getDate() +
        "-" +
        monthArray[dDate.getMonth()] +
        "-" +
        dDate.getFullYear()
    : "Not Available";
} //End of getDateInFormat

/**
 * Accepts donor refernce id as parameter and returns donor's full name
 * @param {Donor reference Id} params
 */
export async function getDonorReference(refId) {
  if (!refId) {
    return `Got ${refId}`;
  }
  try {
    const donorCollection = collection(firestore, "donors");
    const docRef = doc(donorCollection, refId);
    const snapShot = await getDoc(docRef);

    if (snapShot.exists()) {
      const donorData = snapShot.data();
      return donorData;
    } else {
      return "Ref error!";
    }
  } catch (error) {
    console.error("Error fetching donor reference:", error);
    return null;
  }
}

export function GetDonorField(props) {
  const [refDetails, setRefDetails] = useState("");

  useEffect(() => {
    const refId = props.donorId;
    const fieldNameArray = props.fieldName;

    if (!!firestore && refId !== null && refId.length > 0) {
      const donorCollection = collection(firestore, "donors");
      const docRef = doc(donorCollection, refId);

      const unsubSnapShot = onSnapshot(docRef, (snapshot) => {
        if (snapshot.exists()) {
          let data = snapshot.data();

          fieldNameArray.forEach((fieldName) => {
            if (data !== undefined) data = data[fieldName];
          });

          data === undefined ? setRefDetails("") : setRefDetails(data);
        }
      });
      return () => unsubSnapShot();
    }
  }, [props.donorId, props.fieldName]); //End of useEffect

  return refDetails;
}
